export const getButtonTitle = ({
    base,
    screenReaderText,
}: {
    base: string;
    screenReaderText?: string;
}) => screenReaderText || base;
